<template>
  <!--style="z-index: 0;"  -->
  <div class="fl pos-rel after-bg-wh" 
    :style="'width:' + width + ';height:' + height"
    :class="{'drag': isDrag || isSort}"
    @mouseup="dragUp($event)"
    @mouseleave="resetAndDeleteInsertPos"
    @mouseover="showInsertPos($event, -1, {})">
    <!-- 排序标签 -->
    <div class="temp-sort" :style="dragStyle" v-show="curSort.default.type">
      <span class="fl">
        <div class="drag-shank" size="small" type="danger">
          <i class="fa fa-arrows fz-24 c-blue"></i>
        </div>
      </span>
      <span class="m-l-10 max-w-400 text-ovferflow">{{curSort.default.title}}</span>
    </div>
    <!-- 排序标签 -->
    <div class="input-list bor-deep-gra h-100p ovf-auto">
      <!-- <div>
        <p class="c-deep-blue p-t-20 p-b-20 p-l-20 m-t-0 m-b-0 bor-b-gray fw-b" v-if="!isChild">表单</p>
        <el-input class="w-200"></el-input>
      </div> -->
      <div class="c-deep-blue p-t-10 p-b-10 p-l-10 m-t-0 m-b-0 bor-b-gray fw-b" v-if="!isChild">
        表单：<el-input class="w-200" v-model="inputListModel"></el-input>
      </div>
      <div class="pos-abs" style="z-index: -1" v-show="isInputListEmpty">请拖拽控件到此区域</div>
      <div v-for="(item, index) in inputList" 
        @mouseover="showInsertPos($event, index, item)"
        :class="{'active-input': item.selected, 'temp-input': item.temp, 'dulpicate': item.isDulpicate}"
        @click="beforeSelectInput($event, item)"
        v-show="!item.hide"
        v-if="item.default && !item.default.is_deleted">
        <span class="fl" v-if="!item.temp">
          <div class="drag-shank" size="small" type="danger" @mousedown="sortDown(item, index)">
            <i class="fa fa-arrows fz-24 c-blue"></i>
          </div>
        </span>
        <span class="m-l-10 fl input-title text-overflow" v-if="!item.temp" :title="item.default.title">{{item.default.title}}</span>
        <div class="m-l-20 fl" v-if="!item.temp">
          <el-input class="h-40 w-150" :disabled="true" v-if="item.default.type == TYPE_INPUTTEXT || item.default.type == TYPE_PASSWORD"></el-input>
          <el-input class="h-50 w-150" type="textarea" :disabled="true" v-if="item.default.type == TYPE_TEXTAREA">
          </el-input>
          <el-radio disabled v-if="item.default.type == TYPE_RADIO">选项</el-radio>
          <el-checkbox disabled v-if="item.default.type == TYPE_CHECKBOX">选项</el-checkbox>
          <el-select class="w-150" disabled placeholder="" v-if="item.default.type == TYPE_SELECT || item.default.type == TYPE_CASCADER"></el-select>
          <el-date-picker class="w-150" disabled type="date" v-if="item.default.type == TYPE_DATE || item.default.type == TYPE_BOTH_DATE_TIME"> </el-date-picker>
          <el-time-select class="w-150" disabled v-if="item.default.type == TYPE_TIME"> </el-time-select>
          <i class="fa fa-upload c-blue fz-24" v-if="item.default.type == TYPE_FILE"></i>
          <i class="fa fa-wpforms c-blue fz-24" v-if="item.default.type == TYPE_EDITOR"></i>
          <i class="fa fa-reply-all c-blue fz-24" v-if="item.default.type == TYPE_FOREIGNKEY"></i>
          <i class="fa fa-asterisk c-blue fz-24" v-if="item.default.type == TYPE_MULTIRELATE"></i>
          <i class="fa fa-th c-blue fz-24" v-if="item.default.type == TYPE_SUBFORM"></i>
          <i class="fa fa-user-o c-blue fz-24" v-if="item.default.type == TYPE_PERSON"></i>
          <i class="fa fa-users c-blue fz-24" v-if="item.default.type == TYPE_STRUCT"></i>
          <i class="fa fa-address-card c-blue fz-24" v-if="item.default.type == TYPE_USER"></i>
          <i class="fa fa-calendar c-blue fz-24" v-if="item.default.type == TYPE_DEALTIME"></i>
          <i class="fa fa-file-code-o c-blue fz-24" v-if="item.default.type == TYPE_PARAMS"></i>
          <i class="fa fa-cogs c-blue fz-24" v-if="item.default.type == TYPE_SUBRELATE"></i>
        </div>
        <span class="fr" v-if="!item.temp && item.default.is_system != 1">
          <el-button size="small" type="danger" @click="deleteInput($event, item, index)">删除</el-button>
        </span>
        <div style="clear:both"></div>
        <div class="subform-area" v-if="!item.temp && item.default.type == TYPE_SUBFORM" @mouseover="resetAndDeleteInsertPos" @click="cancelSelectParent($event)">
          <input-list ref="inputList" :inputList="item.form.data" width="100%" height="300px" :curType="curType" :curInput="curInput" :isDrag="isDrag" @setCurInput="setCurInput" @setIsDrag="setIsDrag" @setCurType="setCurType" @resetFromChild="resetFromChild" @clearInputModel="clearInputModel" :isChild="true"></input-list>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .after-bg-wh:after {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: -2;
    content: ' ';
  }
  .drag-shank {
    width: 50px;
    height: 100%;
    border: 1px dashed #fff;
    text-align: center;
    cursor: move;
  }
  .drag-shank:hover {
    border: 1px dashed #aaa;
  }
  .temp-sort {
    position: fixed;
    width: 200px;
    padding: 15px 30px;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    z-index: -1;
    cursor: move;
  }
  .temp-input {
    border: 1px dashed black;
  }
  .dulpicate {
    border: 2px solid red;
  }
  .input-list > div{
    padding: 15px 30px;
    min-height: 40px;
    line-height: 40px;
    overflow: hidden;
  }
  .active-input {
    position: relative;
  }
  .active-input:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #BFE4FF;
    content: ' ';
    z-index: -1;
  }
  .subform-area {
    min-width: 250px;
    min-height: 30px;
    margin-top: 40px;
    border: 1px dashed #aaa;
    overflow: hidden;
  }
  .input-title {
    width: 150px;
  }
  @media (max-width: 1400px) {
    .input-title {
      width: 70px;
    }
  }
</style>

<script>
  import modelConfig from '../../config/modelConfig'
  import inputList from './inputList'
  export default {
    name: 'inputList',
    props: ['formName', 'inputList', 'width', 'height', 'isDrag', 'curType', 'curInput', 'isChild'],
    data() {
      return {
        COMPONENT_NAME: 'model_inputlist',
        isSort: false,
        curSort: {
          default: {}
        }, // 当前排序的控件
        insertPos: null, // 插入新控件的index
        dragStyle: {},
        isInputListEmpty: true,
        count: 0,
        hasSubForm: false,
        inputListModel: null // 搜索inputList
      }
    },
    mixins: [modelConfig],
    created() {
      if (this.inputList.length) {
        this.isInputListEmpty = false
      }
      this.init()
      // 发现子表单搜索后，内部值不会渲染页面，故重新赋值一遍
      this.inputList = this.inputList
    },
    components: {
      inputList
    },
    methods: {
      init() {
        document.addEventListener('mouseover', (event) => {
          this.resetAndDeleteInsertPos()
        })
        document.addEventListener('mousemove', (event) => {
          if (this.isSort) {
            this.setDragStyle(event)
          }
        })
        document.addEventListener('mouseup', (event) => {
          this.isSort = false
          this.curSort.hide = false
          this.curSort = { default: { }}
        })
      },
      beforeSelectInput(event, item) { // 选择控件前取消冒泡
        event.stopPropagation()
        this.selectInput(item)
      },
      selectInput(item) {
        this.setCurInput(item)
      },
      setDragStyle(event) {
        this.dragStyle = {
          top: event.pageY - 40 + 'px',
          left: event.pageX - 50 + 'px'
        }
      },
      dragUp(event) { // 处理拖拽结果
        event.stopPropagation()
        if (!this.isDrag && !this.isSort) {
          return
        }
        if (this.isDrag) {
          this.setIsDrag(false)
          this.addInput(this.curType.id)
          this.resetInsertPos()
          this.setCurType({})
        } else if (this.isSort) {
          this.isSort = false
          this.sortInput()
          this.resetInsertPos()
          this.curSort = { default: { }}
        }
        this.setDragStyle(event)
      },
      setCurType(item) {
        this.$emit('setCurType', item)
      },
      setIsDrag(item) {
        this.$emit('setIsDrag', item)
      },
      setCurInput(item) {
        this.$emit('setCurInput', item)
      },
      createInput(type) {
        let baseInput = require('./widgetAttr/index')
        let newInput = _.cloneDeep(baseInput)
        let attr = null
        if (type == this.TYPE_INPUTTEXT) {
          // 单行文本
          attr = require('./widgetAttr/text')
        } else if (type == this.TYPE_PASSWORD) {
          // 密码
          attr = require('./widgetAttr/password')
        } else if (type == this.TYPE_TEXTAREA) {
          // 多行文本
          attr = require('./widgetAttr/textarea')
        } else if (type == this.TYPE_RADIO) {
          // 单选框
          attr = require('./widgetAttr/radio')
        } else if (type == this.TYPE_CHECKBOX) {
          // 多选框
          attr = require('./widgetAttr/checkbox')
        } else if (type == this.TYPE_SELECT) {
          // 下拉框
          attr = require('./widgetAttr/select')
        } else if (type == this.TYPE_DATE) {
          // 日期
          attr = require('./widgetAttr/date')
        } else if (type == this.TYPE_TIME) {
          // 时间
          attr = require('./widgetAttr/time')
        } else if (type == this.TYPE_BOTH_DATE_TIME) {
          // 时间日期
          attr = require('./widgetAttr/datetime')
        } else if (type == this.TYPE_FILE) {
          // 文件
          attr = require('./widgetAttr/file')
        } else if (type == this.TYPE_EDITOR) {
          // 编辑器
          attr = require('./widgetAttr/editor')
        } else if (type == this.TYPE_STRUCT) {
          // 部门选择
          attr = require('./widgetAttr/struct')
        } else if (type == this.TYPE_PERSON) {
          // 人员选择
          attr = require('./widgetAttr/people')
        } else if (type == this.TYPE_CASCADER) {
          // 级联选择
          attr = require('./widgetAttr/cascader')
        } else if (type == this.TYPE_FOREIGNKEY) {
          // 外键
          attr = require('./widgetAttr/foreignKey')
        } else if (type == this.TYPE_MULTIRELATE) {
          // 多对多关联
          attr = require('./widgetAttr/multiRelate')
        } else if (type == this.TYPE_SUBFORM) {
          // 子表单
          attr = require('./widgetAttr/subform')
        } else if (type == this.TYPE_USER) {
          // 用户信息
          attr = require('./widgetAttr/userInfo')
        } else if (type == this.TYPE_DEALTIME) {
          attr = require('./widgetAttr/dealtime')
        } else if (type == this.TYPE_PARAMS) {
          attr = require('./widgetAttr/params')
        } else if (type == this.TYPE_SUBRELATE) {
          attr = require('./widgetAttr/subRelate')
        } else if (type == this.TYPE_PHOTO) {
          attr = require('./widgetAttr/photo')
        } else if (type == this.TYPE_OBTAIN_CONTENT) {
          // 获取接口内容
          attr = require('./widgetAttr/interface')
        }
        if (type == this.TYPE_FILE || type == this.TYPE_EDITOR) {
          // 文件或富文本编辑器，默认不显示和不筛选
          newInput.is_show = 0
          newInput.is_filter = 0
        }
        newInput.hide = false
        newInput = _.merge(newInput, _.cloneDeep(attr))
        return newInput
      },
      clearInputModel() {
        this.inputListModel = null
        // 如果搜索框值为空 ，则赋值全部
        this.clearInputList('hide', false)
      },
      addInput(type, data, isText) {  // 添加控件
        this.$emit('clearInputModel')
        if (this.isChild && type == this.TYPE_SUBFORM) {
          this.resetAndDeleteInsertPos()
          _g.toastMsg(this, 'error', '子表单内不能再添加子表单')
          return
        }
        // if (type == this.TYPE_SUBFORM && this.hasSubForm) {
        //   this.resetAndDeleteInsertPos()
        //   _g.toastMsg(this, 'error', '只能添加一个子表单控件')
        //   return
        // }
        let newInput = this.createInput(type)
        if (data) { // 有提供值
          newInput.default.title = data.title
          newInput.default.name = `${this.formName}_${data.name}`
          newInput.default.tips = data.tips
          newInput.default.is_needed = data.is_needed
          newInput.default.type = type
        } else {  // 使用默认值
          if (type == this.TYPE_DEALTIME) {
            newInput.default.title = '创建时间'
          } else {
            newInput.default.title = this.curType.name
          }
          newInput.default.name = this.getUniqueName(this.curType.field_name)
          newInput.default.type = type
        }
        let success = false
        if (isText) { // 文本形式添加
          if (data) {
            this.inputList.push(newInput)
            success = true
          }
        } else {  // 普通拖拽插入
          if (this.insertPos != null) {
            this.inputList.splice(this.insertPos, 1, newInput)
            success = true
          }
        }
        if (success) {
          // if (type == this.TYPE_SUBFORM) {
          //   this.hasSubForm = true
          // }
          this.selectInput(newInput)
        }
      },
      sortInput() { // 控件排序
        if (this.insertPos != null) {
          delete this.curSort.hide
          let sourceIndex = _.indexOf(this.inputList, this.curSort)
          this.inputList.splice(this.insertPos, 1, this.curSort)
          this.inputList.splice(sourceIndex, 1)
        }
      },
      deleteInput(event, item, index) {  // 删除控件
        event.stopPropagation()
        if (_.eq(this.curInput, item)) {
          this.setCurInput({ default: { }})
        }
        // if (this.inputList[index].default.type == this.TYPE_SUBFORM) {
        //   this.hasSubForm = false
        // }
        if (item.default.field_id) {
          item.default.is_deleted = 1
        } else {
          this.inputList.splice(index, 1)
          // console.log('删除input')
        }
      },
      resetInsertPos() { // 重置插入的位置
        if (this.insertPos != null) {
          this.insertPos = null
        }
      },
      resetFromChild() {
        if (this.curSort.hide != undefined) {
          delete this.curSort.hide
        }
        this.resetAndDeleteInsertPos()
      },
      resetAndDeleteInsertPos() {
        if (this.insertPos != null) {
          this.inputList.splice(this.insertPos, 1)
          this.insertPos = null
        }
      },
      resetParentInsertPos() {
        this.$emit('resetFromChild')
      },
      showInsertPos(event, index, item) {  // 显示插入的位置（绑定在已添加控件上）
        event.stopPropagation()
        this.resetParentInsertPos()
        if (!this.isDrag && !this.isSort) {
          return
        }
        if (this.insertPos == index) {
          return
        }
        if (this.isDrag && item.default && item.default.type == this.TYPE_SUBFORM) {
          // 对子表单进行特殊处理：进入子表单控件区域后，移除显示的插入位置
          this.resetAndDeleteInsertPos()
          return
        }
        let tempInput = {
          temp: true,
          default: {}
        }
        this.resetAndDeleteInsertPos()
        if (index != -1) {
          this.insertPos = index
          this.inputList.splice(index, 0, tempInput)
        } else {
          this.insertPos = this.inputList.length
          this.inputList.push(tempInput)
        }
      },
      sortDown(item, index) { // 点击某个控件排序
        this.isSort = true
        item.hide = true
        this.curSort = item
        this.selectInput(item)
      },
      checkInputListEmpty() {
        if (this.inputList && !this.inputList.length) {
          return true
        } else {
          let deleteLen = 0
          _(this.inputList).forEach((res) => {
            if (res.default.is_deleted) {
              deleteLen++
            } else {
              deleteLen = -1
              return
            }
          })
          if (deleteLen == this.inputList.length) {
            return true
          }
        }
        return false
      },
      getUniqueName(sourceName) {
        return this.searchUniqueName(sourceName, [])
      },
      searchUniqueName(sourceName, array) {
        let ok = false
        this.count++
        if (!array.length) {
          _(this.inputList).forEach((res) => {
            if (res.default.name &&
              !res.default.is_deleted &&
              res.default.name[0] == sourceName[0] &&
              res.default.name.indexOf(sourceName + '_') > -1 &&
              (/_\d+$/g).test(res.default.name)) {
              // 对当前存在的字段名中有可能与当前添加字段名相等的进行筛选，条件如下：
              // 1、字段名存在
              // 2、没有被删除
              // 3、首字母相等
              // 4、包含当前添加字段名子串
              // 5、满足以"_数字"结尾
              array.push(res.default.name)
            }
          })
        }
        // console.log(JSON.stringify(array))
        ok = _.findIndex(array, (res) => {
          return res == sourceName + '_' + this.count
        }) == -1
        if (ok) {
          // 若不存在重复，则输出当前新字段名
          return sourceName + '_' + this.count
        } else {
          // 若存在重复，则count+1，以筛选出来的数组继续进行查重
          return this.searchUniqueName(sourceName, array)
        }
      },
      cancelSelectParent(event) {
        event.stopPropagation()
      },
      clearInputList(key, bool) {
        let data = this.inputList
        _(this.inputList).forEach((item) => {
          item[key] = bool
          // 判断是否有子表单的存在 赋值is_deleted
          if (item.form && item.form.data && item.form.data.length > 0) {
            let tempData = item.form.data
            _(tempData).forEach((res) => {
              res[key] = bool
            })
          }
        })
        // this.inputList = data
        // 取消右侧配置项选择
        this.setCurInput({ default: { }})
      },
      searchInputListModel() {
        // 搜索inputlist值
        if (this.inputList && this.inputList.length > 0) {
          // 清空inputList中的selected true
          this.clearInputList('selected', false)
          _(this.inputList).forEach((item) => {
            let isChildForm = false // 子表单中是否存在对应的数据
            if (item.form && item.form.data && item.form.data.length > 0) {
              _(item.form.data).forEach((childItem) => {
                if (childItem.default.name.indexOf(this.inputListModel) > -1 || childItem.default.title.indexOf(this.inputListModel) > -1) {
                  isChildForm = true
                  childItem.hide = false
                  return
                }
                childItem.hide = true
              })
            }
            if (item.default.name.indexOf(this.inputListModel) > -1 || item.default.title.indexOf(this.inputListModel) > -1 || isChildForm) {
              item.hide = false
              return
            } else {
              item.hide = true
            }
          })
        }
      }
    },
    watch: {
      'inputList'() {
        this.inputListModel = null
        this.isInputListEmpty = this.checkInputListEmpty()
      },
      'inputListModel'() {
        if (!this.isChild) {
          if (this.inputListModel) {
            // 在inputList中搜索数据
            this.searchInputListModel()
            return
          }
          // 如果搜索框值为空 ，则赋值全部
          this.clearInputList('hide', false)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// inputList.vue?25b359dd